import produce from 'immer';

// actions
export const PREVIEW_LOADING = 'PREVIEW_LOADING';
export const PREVIEW_LOADED = 'PREVIEW_LOADED';
export const PREVIEW_FAILED = 'PREVIEW_FAILED';
export const PREVIEW_CANCEL = 'PREVIEW_CANCEL';

export const SHIPMENT_LOADING = 'SHIPMENT_LOADING';
export const SHIPMENT_LOADED = 'SHIPMENT_LOADED';

export const OPEN_SHIPMENT_INFO_EDITOR = 'OPEN_SHIPMENT_INFO_EDITOR';
export const CLOSE_SHIPMENT_INFO_EDITOR = 'CLOSE_SHIPMENT_INFO_EDITOR';
export const SAVE_PREVIEW_SHIPMENT_INFO = 'SAVE_PREVIEW_SHIPMENT_INFO';

export const TEMPLATE_CREATED = 'TEMPLATE_CREATED';
export const LOAD_TEMPLATE_SUCCESSED = 'LOAD_TEMPLATE_SUCCESSED';
export const UPDATE_DATA = 'UPDATE_DATA';
export const CANCEL_CREATE_TEMPLATE = 'CANCEL_CREATE_TEMPLATE';

export const initialState = {
  origVersion: null,
  rawHtml: '',
  previewHtml: '',
  rawJson: '',
  png: '',
  pdf: '',
  shipmentId: '',
  shipmentInfo: '',
  previewLoaded: false,
  isLoadingPreview: false,
  openShipmentInfoEditor: false,
};

export function templateReducer(state, action) {
  switch (action.type) {
    case PREVIEW_CANCEL: {
      return produce(state, (draftState) => {
        draftState.isLoadingPreview = false;
      });
    }
    case PREVIEW_LOADING:
      return { ...state, isLoadingPreview: true };
    case PREVIEW_LOADED:
      return previewLoaded(state, action);
    case SHIPMENT_LOADED:
      return shipmentLoaded(state, action);
    case OPEN_SHIPMENT_INFO_EDITOR:
      return openShipmentInfoEditor(state, action);
    case CLOSE_SHIPMENT_INFO_EDITOR:
      return closeShipmentInfoEditor(state, action);
    case SAVE_PREVIEW_SHIPMENT_INFO:
      return savePreviewShipmentInfo(state, action);
    case TEMPLATE_CREATED:
      return templateCreated();
    case LOAD_TEMPLATE_SUCCESSED:
      return templatedLoaded(state, action);
    case UPDATE_DATA:
      return updateData(state, action);
    case CANCEL_CREATE_TEMPLATE:
      return cancelCreateTemplate();
    default:
      throw new Error();
  }
}

function cancelCreateTemplate() {
  return initialState;
}

function updateData(state, action) {
  const nextState = produce(state, (draftState) => {
    Object.entries(action.data).forEach(([k, v]) => {
      draftState[k] = v;
    });
  });

  return nextState;
}

function templatedLoaded(state, action) {
  return produce(state, (draftState) => {
    const { data } = action;
    draftState.width = data.width;
    draftState.height = data.height;
    draftState.rawHtml = data.html_template || '';
    draftState.rawJson = data.json_template || '';
    draftState.shipmentId = data.shipment_id;
    draftState.shipmentInfo = JSON.parse(data.sample_data || '{}');
    draftState.origVersion = data.version;
  });
}

function templateCreated() {
  return initialState;
}

function savePreviewShipmentInfo(state, action) {
  return produce(state, (draftState) => {
    draftState.shipmentInfo = action.shipmentInfo;
    draftState.openShipmentInfoEditor = false;
  });
}

function openShipmentInfoEditor(state, action) {
  return produce(state, (draftState) => {
    draftState.openShipmentInfoEditor = true;
  });
}

function closeShipmentInfoEditor(state, action) {
  return produce(state, (draftState) => {
    draftState.openShipmentInfoEditor = false;
  });
}

function previewLoaded(state, action) {
  return produce(state, (draftState) => {
    draftState.previewLoaded = true;
    draftState.isLoadingPreview = false;
    if (action.pdf) draftState.pdf = action.pdf;
    if (action.png) draftState.png = action.png;
    if (action.previewHtml) draftState.previewHtml = action.previewHtml;
  });
}

function shipmentLoaded(state, action) {
  return produce(state, (draftState) => {
    draftState.shipmentId = action.shipmentId;
    draftState.shipmentInfo = action.data;
  });
}
